export const validation = {
  admin: {
    categoriesPanel: {
      titleIsRequired: 'Title is required',
    },
    etlConfig: {
      atLeastOneDomainIsRequired: 'At least one domain is required',
      platformIsRequired: 'Platform is required',
      topicIsRequired: 'Topic is required',
    },
    externalToolsPanel: {
      atLeastOneCategoryIsRequired: 'At least one category is required',
      descriptionIsRequired: 'Description is required',
      urlIsRequired: 'URL is required',
    },
    mcpCatalogPanel: {
      mustBeAValidUrl: 'Must be a valid URL',
      nameIsRequired: 'Name is required',
    },
  },
  audiences: {
    createPersonaForm: {
      ageIsRequired: 'Age is required',
      countryIsRequired: 'Country is required',
      mustBeAValidGwiAudienceUuid: 'Must be a valid GWI audience UUID',
      pickAtLeastOneWorkspace: 'Select at least one workspace',
      professionIsRequired: 'Profession is required',
      segmentDescriptionIsRequired: 'Segment description is required',
      segmentIsRequired: 'Segment is required',
      spaceVisibilityIsRequired: 'Space visibility is required',
    },
    editPersonaForm: {
      ageIsRequired: 'Age is required',
      annualIncomeIsRequired: 'Annual income is required',
      atLeastOneGainIsRequired: 'At least one gain is required',
      atLeastOneItemIsRequired: 'At least one item is required',
      atLeastOnePainIsRequired: 'At least one pain is required',
      descriptionIsRequired: 'Description is required',
      educationIsRequired: 'Education is required',
      familyCompositionIsRequired: 'Family composition is required',
      genderIsRequired: 'Gender is required',
      itemIsRequired: 'Item is required',
      lifeStageIsRequired: 'Life stage is required',
      locationIsRequired: 'Location is required',
      mustBeAValidGwiAudienceUuid: 'Must be a valid GWI audience UUID',
      pickAtLeastOneWorkspace: 'Select at least one workspace',
      quoteIsRequired: 'Quote is required',
      segmentIsRequired: 'Segment is required',
      spaceVisibilityIsRequired: 'Space visibility is required',
    },
  },
  contentTest: {
    setupForm: {
      captionIsRequired: 'Caption is required',
      platformIsRequired: 'Platform is required',
      selectAVideoModel: 'Select a video model',
      selectAtLeastOnePersona: 'Select at least one persona',
      titleIsRequired: 'Title is required',
      titleMaxLength: 'Title must be {{max}} characters or fewer',
    },
  },
  editBrief: {
    editBriefModal: {
      briefNameIsRequired: 'Brief name is required',
      nameIsTooLong: 'Name is too long',
    },
  },
  knowledgeHub: {
    briefTemplateBuilder: {
      atLeastOneSectionIsRequired: 'At least one section is required',
      descriptionIsRequired: 'Description is required',
      nameIsRequired: 'Name is required',
    },
  },
  manageProjectFiles: {
    renameFileModal: {
      fileNameIsRequired: 'File name is required',
      nameIsTooLong: 'Name is too long',
    },
  },
  nacbIntake: {
    intakeForm: {
      brandIsRequired: 'Brand is required',
      businessSituationIsRequired: 'Business situation is required',
      involvementLevelIsRequired: 'Involvement level is required',
      maxCharacters: 'Max {{max}} characters',
      nameIsRequired: 'Name is required',
      turnaroundTimeframeIsRequired: 'Turnaround timeframe is required',
    },
  },
  project: {
    projectForm: {
      descriptionIsRequired: 'Description is required',
      descriptionMaxLength: 'Description must be {{max}} characters or fewer',
      marketIsRequired: 'Market is required',
      projectTypeIsRequired: 'Project type is required',
      startDateBeforeDeadline: 'Start date must be on or before the deadline',
      titleIsRequired: 'Title is required',
      titleMaxLength: 'Title must be {{max}} characters or fewer',
    },
  },
  reelBrief: {
    reelBriefForm: {
      briefingIsRequired: 'Briefing is required',
      titleIsRequired: 'Title is required',
    },
  },
  supportRequest: {
    supportRequestFields: {
      areaIsRequired: 'Area is required',
      blockerAnswerIsRequired: 'Tell us whether this is a blocker for you',
      currentBehaviorIsRequired: 'Current behavior is required',
      descriptionIsRequired: 'Description is required',
      frequencyIsRequired: 'Frequency is required',
      tooManyAttachments: 'You can attach up to {{count}} files',
    },
  },
} as const;
